module.exports = __webpack_public_path__ + "img/updated.ca19f852.svg";